/**
 * Zjištění, zda má uživatel právo na danou roli.
 * @param authInfo login info
 * @param moduleCode kód modulu, např. SR
 * @param kodRole kód role, např. SrUzivatelRole.REFERENT
 * @return {boolean} ture, pokud má uživatel právo na danou roli
 */
export function hasRole(authInfo, moduleCode, kodRole) {
    return getRole(authInfo, moduleCode, kodRole) !== null;
}

/**
 * Načte roli pro konkrétní modul a kód role (např. SrUzivatelRole.REFERENT)
 * @param authInfo login info
 * @param moduleCode kód modulu, např. SR
 * @param kodRole kód role, např. SrUzivatelRole.REFERENT
 * @return info o rolie nebo null
 */
export function getRole(authInfo, moduleCode, kodRole) {
    if (authInfo.moduleInfos && authInfo.moduleInfos[moduleCode] && authInfo.moduleInfos[moduleCode].roles) {
        const roles = authInfo.moduleInfos[moduleCode].roles;
        for (let a=0; a<roles.length; a++) {
            if (roles[a].kod === kodRole) {
                return roles[a];
            }
        }
    }
    return null;
}
